import { httpClient } from "../http/httpClient"

export interface UploadFilesRequest {
  url: string
  code: string
  name: string
  files: File[]
}
export async function uploadFiles({ url, code, name, files }: UploadFilesRequest) {
  const formData = new FormData()
  formData.append('url', url)
  formData.append('name', name)
  formData.append('code', code)

  files.forEach((file, index) => {
    formData.append(`arquivo_${index}`, file)
  })

  const response = await httpClient
    .put<any>(`/crefisa/files`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .catch((error) => {
      throw error.response?.data || error
    })
  return response.data
}
